import { CircularProgress, Divider } from '@mui/material';
import React from 'react';

import s from './TaskLoading.module.scss';

type TaskLoadingProps = {
  isLoading: boolean;
};

export const TaskLoading: React.FC<TaskLoadingProps> = ({ isLoading }) => {
  if (!isLoading) return null;

  return (
    <>
      <Divider />
      <div className={s.loading}>
        <CircularProgress size={20} />
        <span>Загрузка данных задачи...</span>
      </div>
    </>
  );
};
